import React, { FC } from 'react';
import { Text } from '@chakra-ui/react';

interface EmptyListProps {
  title: string;
}

const EmptyContent: FC<EmptyListProps> = ({
  title,
}) => (
  <Text
    align='center'
    fontSize='xs'
    color='gray.500'
    m={3}
    fontWeight='medium'
  >
    {title || 'No hay elementos para mostrar'}
  </Text>
);

export default EmptyContent;
